/**
 * byrna-cart-chat-toggle.js — #1364
 *
 * Hides the Zendesk chat launcher while the cart side-drawer is open, so the
 * floating bubble never overlaps the state selector / checkout button on mobile.
 *
 * Trigger: the drawer toggles `.is-visible` on `.ajax-cart__overlay`
 *          (see z__jsAjaxCart.js showDrawer/hideDrawer). We observe that class
 *          rather than patching the core cart script.
 *
 * Action:  Zendesk Messenger API — zE('messenger', 'hide' | 'show').
 *          Falls back to a CSS class on <html> if zE isn't ready yet.
 */
(function () {
  'use strict';

  var hidden = null; // tracks last applied state so we don't spam the API

  function setChatHidden(hide) {
    if (hidden === hide) return;
    hidden = hide;

    // Primary: Zendesk Messenger API (this store uses zE('messenger', ...))
    if (typeof window.zE === 'function') {
      try {
        window.zE('messenger', hide ? 'hide' : 'show');
        return;
      } catch (e) { /* fall through to CSS fallback */ }
    }

    // Fallback: CSS hides the launcher iframe while the class is present.
    document.documentElement.classList.toggle('byrna-cart-open', hide);
  }

  function watch(el) {
    if (!el) return;
    var observer = new MutationObserver(function () {
      setChatHidden(el.classList.contains('is-visible'));
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    // Sync once in case the drawer is already open on load.
    setChatHidden(el.classList.contains('is-visible'));
  }

  function init() {
    // Overlay is the most reliable signal; fall back to the drawer element.
    var target = document.querySelector('.ajax-cart__overlay')
      || document.querySelector('[data-ajax-cart-drawer]');
    watch(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
